"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDigitalGiftCardSku = exports.isGiftCardSku = exports.GIFT_CARD_SKUS = exports.DIGITAL_GIFT_CARD_SKU = exports.getProductVariantBySku = exports.getProductKeyFromSku = void 0;
const getProductKeyFromSku = (sku) => {
    return (sku && sku.slice(0, 8)) || '';
};
exports.getProductKeyFromSku = getProductKeyFromSku;
const getProductVariantBySku = (parentProduct, variantSKU) => {
    const { masterVariant, variants } = isProduct(parentProduct)
        ? {
            masterVariant: parentProduct.masterData.current.masterVariant,
            variants: parentProduct.masterData.current.variants,
        }
        : { masterVariant: parentProduct.masterVariant, variants: parentProduct.variants };
    if (masterVariant.key === variantSKU) {
        return masterVariant;
    }
    return variants.find((variant) => variant.key === variantSKU);
};
exports.getProductVariantBySku = getProductVariantBySku;
const isProduct = (product) => {
    return !!product.masterData;
};
exports.DIGITAL_GIFT_CARD_SKU = '20344335';
exports.GIFT_CARD_SKUS = [exports.DIGITAL_GIFT_CARD_SKU, '20300010', '20300000'];
const isGiftCardSku = (sku) => {
    if (!sku)
        return false;
    return exports.GIFT_CARD_SKUS.some((giftCardSku) => sku.startsWith(giftCardSku));
};
exports.isGiftCardSku = isGiftCardSku;
const isDigitalGiftCardSku = (sku) => {
    if (!sku)
        return false;
    return sku.startsWith(exports.DIGITAL_GIFT_CARD_SKU);
};
exports.isDigitalGiftCardSku = isDigitalGiftCardSku;
//# sourceMappingURL=index.js.map